import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-edit-form-skeleton',
  imports: [Skeleton],
  templateUrl: './edit-form-skeleton.html',
})
export class EditFormSkeleton {}
